// App.tsx or your main component
import React from 'react';
import { Tabs } from 'antd';
import ReportActionConfig from './ReportActionConfig';
import RowActionConfig from './RowActionConfig';
import ReportConfig from './ReportConfig';

const { TabPane } = Tabs;
const items = [
    {
      key: '1',
      label: 'Report Action Config',
      children: <ReportActionConfig />,
    },
    {
      key: '2',
      label: 'Row Action Config',
      children: <RowActionConfig />,
    },
    {
        key: '3',
        label: 'Report Config',
        children: <ReportConfig />,
    }
  ];

const ReportActionBuilder: React.FC = () => {
    return (
        <div style={{ padding: 20 }}>
            <Tabs defaultActiveKey="1" type="card" items={items}>
                {/* <TabPane tab="Report Action Config" key="1">
                    <ReportActionConfig />
                </TabPane>
                <TabPane tab="Row Action Config" key="2">
                    <RowActionConfig />
                </TabPane>
                <TabPane tab="Report Config" key="3">
                    <ReportConfig />
                </TabPane> */}
            </Tabs>

        </div>
    );
};

export default ReportActionBuilder;
